import {
  MOBILE_BREAKPOINT,
  TABLET_BREAKPOINT,
} from 'src/js/modules/breakpoint-editing/constants/breakpoints';
import getResponsiveFontSize from './get-responsive-font-size';
import getLineHeightEm from './get-line-height-em';

const buildAutofillValue = (fontSize, breakpoint) => {
  const fontSizeAtBreakpoint = getResponsiveFontSize(fontSize, breakpoint);
  const lineHeightAtBreakpoint = Math.round(
    getLineHeightEm(fontSize, breakpoint) * fontSizeAtBreakpoint
  );

  return `[${fontSizeAtBreakpoint}px]/[${lineHeightAtBreakpoint}px]`;
};

const getFontSizeAutofill = (fontSize, currentBreakpoint) => {
  const autofill = {};

  if (!currentBreakpoint) {
    const tabletFontSize = getResponsiveFontSize(fontSize, TABLET_BREAKPOINT);
    const mobileFontSize = getResponsiveFontSize(fontSize, MOBILE_BREAKPOINT);

    if (tabletFontSize !== fontSize) {
      autofill[TABLET_BREAKPOINT] = buildAutofillValue(fontSize, TABLET_BREAKPOINT);
    }

    // The tablet class cascades down to mobile widths, so a mobile class
    // with the same font size would be redundant.
    if (mobileFontSize !== tabletFontSize) {
      autofill[MOBILE_BREAKPOINT] = buildAutofillValue(fontSize, MOBILE_BREAKPOINT);
    }
  } else if (currentBreakpoint === TABLET_BREAKPOINT) {
    const mobileFontSize = getResponsiveFontSize(fontSize, MOBILE_BREAKPOINT);

    if (mobileFontSize !== fontSize) {
      autofill[MOBILE_BREAKPOINT] = buildAutofillValue(fontSize, MOBILE_BREAKPOINT);
    }
  }

  return Object.keys(autofill).length > 0 ? autofill : null;
};

export default getFontSizeAutofill;
